"use strict";

import {find, findIn, findAllIn, on, addClass, hasClass, removeClass,closest} from "@c0necto/elements-dom-utils";
import {onFind} from "@c0necto/elements-init-modules-in-scope";
import {openOverlay} from "./overlay-toggle";
import loadScript from '@c0necto/elements-load-script';
import fetch from '@c0necto/elements-fetch';

let clearNotification = 0;

export function init () {
    onFind('.js-pool-enquiry', function (element) {
        loadScript("//live.anfrageassistent4you.com/js/anfrage.js").then(() => {
            element = closest('.js-pool-enquiry__parent',element)
            let enquiryButtons = findAllIn('.js-pool-enquiry__btn', element);
            let poolEnquiryToggleBtn = findIn('.js-pool-enquiry__toggle', element);
            let poolEnquiryOverlayToggleBtn = findIn('.js-pool-enquiry__overlay-toggle', element);
            let poolEnquiryShowForm = findIn('.js-pool-enquiry__show-form', element);
            let poolEnquiryAa4yContainer = findIn('.js-pool-enquiry__aa4y', element);


            on('showNotification.pool-enquiry', (evt) => {
                clearNotification++;

                // hide notification after some seconds
                setTimeout(function(){
                    if(clearNotification === 1){
                        find('.js-alert-notification').innerHTML = '';
                    }
                    clearNotification--;

                }, 3500);
            } , document);


            // Acco Toogle for enquiry functinality
            const accoPoolEnquiryClickHandler = evt => {
                evt.preventDefault();

                if(hasClass('enquiry-active',element)){
                    removeClass('enquiry-active',element);
                }else{
                    addClass('enquiry-active',element);
                    let overlayToggle = findIn('.js-overlay__toggle', element);

                    addClass('blink',overlayToggle);

                    setTimeout(function(){
                        removeClass('blink',overlayToggle);
                    }, 2000);

                }
            };

            if (poolEnquiryToggleBtn){
                on('click', accoPoolEnquiryClickHandler, poolEnquiryToggleBtn);
            }

            // Acco enquiry button handler
            const enquiryBtnClickHandler = (evt, btn) => {
                // remove max items notificaton
                // clearAll();

                if(hasClass('active',btn)){
                    let overlayToggle = findIn('.js-overlay__toggle', element);

                    addClass('blink',overlayToggle);

                    setTimeout(function(){
                        removeClass('blink',overlayToggle);
                    }, 2000);

                    let overlay = findIn('.js-overlay',element);
                    openOverlay(overlay);

                    aa4y(element);
                }

            };

            enquiryButtons.forEach((btn) => {
                on('click', (evt) => enquiryBtnClickHandler(evt, btn), btn);
            });


            // Acco Show aa4y Formular
            const accoPoolShowFormClickHandler = evt => {
                evt.preventDefault();

                if (poolEnquiryAa4yContainer){
                    if(!hasClass('is-visible',poolEnquiryAa4yContainer)){
                        addClass('is-visible',poolEnquiryAa4yContainer);
                    }
                }

            };

            if (poolEnquiryShowForm){
                on('click', accoPoolShowFormClickHandler, poolEnquiryShowForm);
            }


            // Acco Overlay Toggle
            const accoPoolOverlayToggleClickHandler = evt => {
                let overlay = closest('.js-overlay', evt.target);

                if(hasClass('is-open',overlay)){
                    aa4y(element);
                }
            };

            if (poolEnquiryOverlayToggleBtn){
                on('click', accoPoolOverlayToggleClickHandler, poolEnquiryOverlayToggleBtn);
            }

        }).catch(console.error);


    });

}

function aa4y(element){
    let aa4yFormType = element.getAttribute('data-aa4y-form-type') || 'mehrfach';
    let kognitivIdInputs = findAllIn('.js-pool-enquiry__kognitiv-id', element);
    let kognitivIdsArr = [];

    if (kognitivIdInputs.length !== 0){
        kognitivIdInputs.map((input) => {
            kognitivIdsArr.push(input.value);
        });

        let pendingRequest = fetch( _config.filterIdsRequestUrl)

        pendingRequest.then((res) => {
            return res.clone().json()
        }).then((res) => {
            if (res.success) {
                let filterKognitivIds = res.filterKognitivIds[0];

                let options = {
                    form_type: aa4yFormType,
                    lang: _config.lang,
                    kognitivIds: kognitivIdsArr,
                    form_style: []
                }

                options = {...options, ...filterKognitivIds};

                new Anfrage('aa4y-mehrfach', options);
            }
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                /*Do error stuff*/
                console.error(error);
            }
        });


    }
}